import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuth } from './AuthContext.jsx'

export default function ProtectedRoute({ children }) {
  const { user } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (user === null) navigate('/login', { replace: true })
  }, [user, navigate])

  if (user === undefined || user === null) return null

  return children
}
